import { ref } from 'vue';

// App mirrors the gated review count here. Keep nav imports independent of the
// account store and WebSocket service, which need a component/browser context.
export const mutationReviewNavCount = ref(0);
